
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-cover bg-center" style={{ backgroundImage: 'url(https://public.readdy.ai/ai/img_res/955361b9186e45d1f53c755c62e60ba4.jpg)' }}>
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>
      <div className="relative w-full px-4 md:px-8 lg:px-16 py-32">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            料理の楽しさを<br />あなたに
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed">
            初心者からプロを目指す方まで、一人ひとりに寄り添った料理教室。<br />
            本格的な技術と心温まる食卓を、共に創りましょう。
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button onClick={scrollToContact} className="bg-orange-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-orange-600 transition-all shadow-lg whitespace-nowrap cursor-pointer">
              無料体験レッスンを予約
            </button>
            <button onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })} className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/20 transition-all border-2 border-white whitespace-nowrap cursor-pointer">
              詳しく見る
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
